export const env = {
    ecpMethodEnabled: (process.env.NODE_ENV === 'development') ? process.env.REACT_APP_ECP_METHOD_ENABLED === '1' : process.env.REACT_PROD_ECP_METHOD_ENABLED === '1'
};

//process.env.NODE_ENV === 'development' ? process.env.REACT_APP_API_URL : process.env.REACT_PROD_API_URL